import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, defineAsyncComponent, nextTick } from 'vue';
import { DropdownWrapper } from 'ui-shared-components';


export default /*#__PURE__*/_defineComponent({
  __name: 'multi-select',
  props: {
    options: null,
    error: { type: Boolean, default: false },
    errorMessage: { default: '' },
    value: null,
    label: null,
    placeholder: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["input", "update:value"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'input' | 'update:value', val: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { options: { name: string, id: string }[], error: boolean, errorMessage: string, value?: string[] | string, label?: string, placeholder?: string, disabled: boolean };

const IconClose = defineAsyncComponent(() => import('@white-label-icon/icon-close'));
const IconSearch = defineAsyncComponent(() => import('@white-label-icon/icon-search'));





const search = ref<string>('');
const isOpen = ref<boolean>(false);
const selected = ref<string[]>(props.value ?? []);

watch(() => props.value, (newValue) => {
  selected.value = newValue ?? [];
});

watch(selected, (newVal) => {
  emit('input', newVal)
  emit('update:value', newVal)
})

watch(isOpen, (isNowOpen) => {
  if (!isNowOpen) {
    search.value = '';
  }
});

const filteredOptions = computed(() =>
  props.options
    .filter((option) => option.name.toLowerCase().includes(search.value.toLowerCase()))
    .filter((option) => !selected.value.includes(option.name))
);

const selectOption = (item: { id: string; name: string }) => {
  selected.value = [...selected.value, item.name]
  search.value = ''
  isOpen.value = false
};

const onDropdownInput = (item: { name: string, id: string }) => {
  selectOption(item)
};
const removeOption = (option: string) => {
  selected.value = selected.value.filter((selected) => selected !== option)
};

const dropdownWrapperValue = computed(() => {
  return { name: search.value };
});

const focusFirstOption = () => {
  nextTick(() => {
    const firstItem = document.querySelector('.dropdown-item');
    if (firstItem) {
      (firstItem as HTMLElement).focus();
    }
  })
}

expose({
  selected,
  search,
  isOpen,
  filteredOptions,
  selectOption,
  removeOption,
  dropdownWrapperValue,
  onDropdownInput,
  focusFirstOption
});

return { __sfc: true,IconClose, IconSearch, props, emit, search, isOpen, selected, filteredOptions, selectOption, onDropdownInput, removeOption, dropdownWrapperValue, focusFirstOption, DropdownWrapper }
}

})